import { api } from './api'
import { API_ENDPOINTS } from '../constants/api'

export interface ClientAuthRequest {
  email: string
  password: string
}

export interface ClientAuthResponse {
  access_token: string
  refresh_token: string
  expires_at: string
  client: Client
}

export interface Client {
  id: number
  uuid: string
  email: string
  first_name: string
  last_name: string
  phone: string
  is_active: boolean
  last_login_at?: string
  created_at: string
}

export interface ClientProfile {
  id: number
  email: string
  first_name: string
  last_name: string
  phone: string
  is_active: boolean
}

export const clientAuthService = {
  async login(email: string, password: string): Promise<ClientAuthResponse> {
    const response = await api.post<ClientAuthResponse>(API_ENDPOINTS.CLIENT.AUTH.LOGIN, { email, password })
    api.setToken(response.access_token)
    return response
  },

  async refresh(refreshToken: string): Promise<ClientAuthResponse> {
    const response = await api.post<ClientAuthResponse>(API_ENDPOINTS.CLIENT.AUTH.REFRESH, { refresh_token: refreshToken })
    api.setToken(response.access_token)
    return response
  },

  async logout(): Promise<void> {
    // Call backend logout if needed
    api.clearToken()
  },

  async getProfile(token?: string): Promise<ClientProfile> {
    if (token) {
      api.setToken(token)
    }
    return api.get<ClientProfile>(API_ENDPOINTS.CLIENT.AUTH.PROFILE)
  },

  async updateProfile(_clientId: number, updates: Partial<ClientProfile>): Promise<ClientProfile> {
    return api.put<ClientProfile>(API_ENDPOINTS.CLIENT.PROFILE, updates)
  },

  async changePassword(currentPassword: string, newPassword: string): Promise<void> {
    await api.post(API_ENDPOINTS.CLIENT.AUTH.CHANGE_PASSWORD, { currentPassword, newPassword })
  },
}